'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const OpenInNew = _ref => {
  let {
    fill,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none"
  }, rest), children, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.66472 13.9997H10.0439C11.5198 13.9997 12.7087 12.8108 12.7087 11.335V6.82543C12.7087 6.47696 12.4422 6.21049 12.0937 6.21049C11.7453 6.21049 11.4788 6.47696 11.4788 6.82543V11.335C11.4788 12.1344 10.8434 12.7698 10.0439 12.7698H2.66472C1.8653 12.7698 1.22987 12.1344 1.22987 11.335V3.95573C1.22987 3.15632 1.8653 2.52089 2.66472 2.52089H7.17424C7.5227 2.52089 7.78917 2.25441 7.78917 1.90595C7.78917 1.55749 7.5227 1.29102 7.17424 1.29102H2.66472C1.18887 1.29102 0 2.47989 0 3.95573V11.335C0 12.8108 1.18887 13.9997 2.66472 13.9997Z",
    fill: fill ?? 'currentColor'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.0186 4.38654V0.635433C14.0186 0.594437 14.0186 0.553441 13.9981 0.512446C13.9981 0.491948 13.9981 0.47145 13.9776 0.47145C13.9776 0.450952 13.9571 0.430454 13.9571 0.409956C13.9571 0.389459 13.9366 0.368961 13.9161 0.348463C13.9161 0.327965 13.8956 0.307467 13.8956 0.307467C13.8546 0.245974 13.7931 0.18448 13.7316 0.143485L13.6906 0.122987C13.6496 0.0614934 13.6086 0.0409956 13.5676 0.0409956L13.5061 0.0204977C13.4652 0.0204977 13.4242 0 13.3832 0H9.63206C9.2836 0 9.01713 0.266472 9.01713 0.614935C9.01713 0.963398 9.2836 1.22987 9.63206 1.22987H11.9073L6.27042 6.88727C6.02444 7.13324 6.02444 7.5227 6.27042 7.74818C6.51639 7.99415 6.90585 7.99415 7.13133 7.74818L12.7887 2.11128V4.38654C12.7887 4.735 13.0552 5.00147 13.4037 5.00147C13.7316 5.00147 13.9981 4.7145 14.0186 4.38654Z",
    fill: fill ?? 'currentColor'
  }));
};
/* eslint-enable react/prop-types */

exports["default"] = OpenInNew;
